import { FormElementModel } from "./../../../models/FormElementModel";
import {
  emailValidator,
  lengthValidator,
  nipValidator,
  phoneValidator,
  repeatEmailValidator,
  textValidator,
  zipCodeValidator,
} from "../../../../utils/formsValidation";
import { t } from "i18next";

export const userPayForm = (
  watch: any,
  register: any,
  zipCode: boolean,
  phoneNumberRequired: boolean
): FormElementModel[] => [
  {
    name: "firstName",
    type: "text",
    text: t("imie"),
    isLabel: true,
    register: { ...register("firstName", { ...textValidator(true, 3) }) },
  },
  {
    name: "lastName",
    type: "text",
    text: t("nazwisko"),
    isLabel: true,
    register: { ...register("lastName", { ...textValidator(true, 3) }) },
  },
  {
    name: "email",
    type: "text",
    text: "E-mail",
    isLabel: true,
    register: { ...register("email", { ...emailValidator(true) }) },
  },
  {
    name: "repeatEmail",
    type: "text",
    text: t("powtorz_email"),
    isLabel: true,
    register: { ...register("repeatEmail", { ...repeatEmailValidator(true, watch("email", "")) }) },
  },
  phoneNumberRequired
    ? {
        name: "phone",
        type: "number",
        text: t("numer_telefonu"),
        isLabel: true,
        register: { ...register("phone", { ...phoneValidator(true) }) },
      }
    : ({} as FormElementModel),

  zipCode
    ? {
        name: "zipCode",
        type: "text",
        text: t("kod_pocztowy"),
        isLabel: true,
        register: { ...register("zipCode", { required: false }, { ...zipCodeValidator(true) }) },
      }
    : ({} as FormElementModel),
];

export const invoiceForm = (register: any, isCompanyInvoice: boolean): FormElementModel[] => [
  isCompanyInvoice
    ? {
        name: "companyName",
        type: "text",
        text: t("nazwa_firmy"),
        isLabel: true,
        register: { ...register("companyName", { ...lengthValidator(true, 3) }) },
      }
    : ({} as FormElementModel),
  isCompanyInvoice
    ? {
        name: "NIP",
        type: "text",
        text: t("nip"),
        isLabel: true,
        register: { ...register("NIP", { ...nipValidator(true, true) }) },
      }
    : ({} as FormElementModel),
  {
    name: "street",
    type: "text",
    text: t("ulica"),
    isLabel: true,
    register: { ...register("street", { ...textValidator(true, 3) }) },
  },
  {
    name: "houseNumber",
    type: "text",
    text: t("numer_domu"),
    isLabel: true,
    register: { ...register("houseNumber", { required: true }) },
  },
  {
    name: "flatNumber",
    type: "text",
    text: t("numer_mieszkania"),
    isLabel: true,
    register: { ...register("flatNumber", { required: false }) },
  },
  {
    name: "zipCode",
    type: "text",
    text: t("kod_pocztowy"),
    isLabel: true,
    register: { ...register("zipCode", { ...zipCodeValidator(true) }) },
  },
  {
    name: "city",
    type: "text",
    text: t("miejscowosc"),
    isLabel: true,
    register: { ...register("city", { ...textValidator(true, 3) }) },
  },
];

export const recipientInvoiceForm = (register: any): FormElementModel[] => [
  {
    name: "recipient.name",
    type: "text",
    text: t("nazwa_firmy"),
    isLabel: true,
    register: { ...register("recipient.name", { ...lengthValidator(true, 3) }) },
  },
  {
    name: "recipient.postCode",
    type: "text",
    text: t("kod_pocztowy"),
    isLabel: true,
    register: { ...register("recipient.postCode", { ...zipCodeValidator(true) }) },
  },
  {
    name: "recipient.street",
    type: "text",
    text: t("ulica"),
    isLabel: true,
    register: { ...register("recipient.street", { ...textValidator(true, 3) }) },
  },
  {
    name: "recipient.locality",
    type: "text",
    text: t("miejscowosc"),
    isLabel: true,
    register: { ...register("recipient.locality", { ...textValidator(true, 3) }) },
  },
  {
    name: "recipient.houseNumber",
    type: "text",
    text: t("numer_domu"),
    isLabel: true,
    register: { ...register("recipient.houseNumber", { required: true }) },
  },
  {
    name: "recipient.flatNumber",
    type: "text",
    text: t("numer_mieszkania"),
    isLabel: true,
    register: { ...register("recipient.flatNumber", { required: false }) },
  },
  {
    name: "recipient.vatId",
    type: "text",
    text: t("nip"),
    isLabel: true,
    register: { ...register("recipient.vatId", { ...nipValidator(true, true) }) },
  },
];

export const purchaserInvoiceForm = (register: any): FormElementModel[] => [
  {
    name: "purchaser.name",
    type: "text",
    text: t("nazwa_firmy"),
    isLabel: true,
    register: { ...register("purchaser.name", { ...lengthValidator(true, 3) }) },
  },
  {
    name: "purchaser.postCode",
    type: "text",
    text: t("kod_pocztowy"),
    isLabel: true,
    register: { ...register("purchaser.postCode", { ...zipCodeValidator(true) }) },
  },
  {
    name: "purchaser.street",
    type: "text",
    text: t("ulica"),
    isLabel: true,
    register: { ...register("purchaser.street", { ...textValidator(true, 3) }) },
  },
  {
    name: "purchaser.locality",
    type: "text",
    text: t("miejscowosc"),
    isLabel: true,
    register: { ...register("purchaser.locality", { ...textValidator(true, 3) }) },
  },
  {
    name: "purchaser.houseNumber",
    type: "text",
    text: t("numer_domu"),
    isLabel: true,
    register: { ...register("purchaser.houseNumber", { required: true }) },
  },
  {
    name: "purchaser.flatNumber",
    type: "text",
    text: t("numer_mieszkania"),
    isLabel: true,
    register: { ...register("purchaser.flatNumber", { required: false }) },
  },
  {
    name: "purchaser.vatId",
    type: "text",
    text: t("nip"),
    isLabel: true,
    register: { ...register("purchaser.vatId", { ...nipValidator(true, true) }) },
  },
];
